import { useState, useEffect } from 'react';

function useHover(ref) {
    const [isHovered, setIsHovered] = useState(false);
    const handleMouseOver = () => setIsHovered(true);
    const handleMouseOut = () => setIsHovered(false);
    useEffect(() => {
        const node = ref.current;
        if (node) {
            node.addEventListener("mouseover", handleMouseOver);
            node.addEventListener("mouseout", handleMouseOut);
            return () => {
                node.removeEventListener("mouseover", handleMouseOver);
                node.removeEventListener("mouseout", handleMouseOut);
            };
        }
    }, [ref.current] // Recall only if ref changes
    );
    return isHovered;
}

export { useHover };
//# sourceMappingURL=useHover.js.map
